import { styled } from 'styled-components'

import InteracCircle from '@/assets/interac-circle.png'
import { Button } from '@/components/Button/Button'
import { PaytrieTopIcon } from '@/components/widget-components'
import { Pages, useBuySellStore, usePageStateStore } from '@/reducers'
import { SummaryRow } from './SummaryRows'

type SellTransactionProps = {
  sourceWallet: string
  orderId: string
  depositAddress: string | null
}

const SubHeader = styled.h4`
  font-weight: 400;
  margin-bottom: 4px;
`

export const SellTransactionInstructions = ({
  sourceWallet,
  orderId,
  depositAddress,
}: SellTransactionProps) => {
  const goToPage = usePageStateStore.use.goToPage()
  const stableCoinAmount = useBuySellStore.use.stableCoinAmount()
  const stableCoin = useBuySellStore.use.stableCoin()
  return (
    <div
      data-testid="container-sell-instructions"
      className="flex flex-col gap-5"
    >
      <div
        data-testid="container-sell-steps"
        className="grid grid-cols-1 md:grid-cols-3 mb-3 flex-grow"
      >
        <div data-testid="container-sell-heading" className="md:col-span-3">
          <h1 data-testid="text-sell-title" className="uppercase text-2xl">
            Next Steps
          </h1>
          <p data-testid="text-sell-description" className="mb-3">
            Please send {stableCoin} {stableCoinAmount} to PayTrie
            {depositAddress && `(${depositAddress.slice(0, 6)})`}
          </p>
        </div>
        <div data-testid="container-sell-transaction-id">
          <SubHeader data-testid="text-sell-transaction-id-label">
            Transaction ID
          </SubHeader>
          <div data-testid="text-sell-transaction-id-value" className="text-xs">
            {orderId}
          </div>
        </div>
        <div data-testid="container-sell-receive">
          <SubHeader data-testid="text-sell-receive-label">Receive</SubHeader>
          <div
            data-testid="container-sell-receive-method"
            className="flex items-start"
          >
            <img
              data-testid="img-sell-interac"
              src={InteracCircle}
              className="mr-1 mt-1"
              height={15}
              width={15}
            />
            <div>
              <div data-testid="text-sell-etransfer" className="font-normal">
                e-Transfer
              </div>
              <div data-testid="text-sell-interac" className="text-sm">
                Interac
              </div>
            </div>
          </div>
        </div>
        <div data-testid="container-sell-from">
          <SubHeader data-testid="text-sell-from-label">From</SubHeader>
          <div
            data-testid="text-sell-from-value"
            className="text-xs"
          >{`${sourceWallet.slice(0, 4)}...${sourceWallet.slice(-4)}`}</div>
        </div>
        <div data-testid="container-sell-to">
          <SubHeader data-testid="text-sell-to-label">To</SubHeader>
          <div data-testid="container-sell-to-details" className="flex gap-2">
            <PaytrieTopIcon data-testid="icon-sell-paytrie" />{' '}
            <div>
              <div data-testid="text-sell-to-name">Paytrie</div>
              <div data-testid="text-sell-to-wallet" className="text-xs">
                {depositAddress}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SummaryRow data-testid="container-sell-summary-row" />
      <Button
        data-testid="btn-sell-start-over"
        onClick={() => goToPage(Pages.CALC)}
      >
        Start over
      </Button>
    </div>
  )
}
